import React, { useEffect, useState, useCallback } from 'react'
import ConfiguracionLogic from '../../functions/logic/Configuracion'
import Select from 'react-select'

export default function Empresas(props) {
    const [identificacion, setIdentificacion] = useState('')
    const [ruc, setRuc] = useState('')
    const [codigoIden, setCodIden] = useState('')
    const [nombre, setNombre] = useState('')
    const [siglas, setSiglas] = useState('')
    const [direccion, setDireccion] = useState('')
    const [representante, setRepresentanteLegal] = useState('')
    const [groupId, setGroupId] = useState('')
    const [esActivo, setActivo] = useState('')
    const [objGrupo, setObjGrupo] = useState([])

    const getGroup = useCallback(async (idGroup, page, perPage) => {
        const resp = await ConfiguracionLogic.grupoLogic(idGroup, page, perPage, '')
        if (resp.success) {
            const areas = resp.data
                .filter(area => area.Nombre && area.Nombre.trim() !== '')
                .map(area => ({
                    value: area.id,
                    label: area.Nombre
                }))
            setObjGrupo(areas)
        }
    }, [])

    useEffect(() => {

        getGroup(0, 1, 100);

        console.log(props.formData.data)

        const storedIdentificacion = localStorage.getItem("idemEmpre");
        const storedRuc = localStorage.getItem("rucEmp");
        const storedCodIden = localStorage.getItem("codIdEmp");
        const storedNombre = localStorage.getItem("nombEmp");
        const storedSiglas = localStorage.getItem("sigEmp");
        const storedActivo = localStorage.getItem("activEmp");
        const storedGroupId = localStorage.getItem("groupEmp");
        const storedRepresentanteLegal = localStorage.getItem("repreEmpre");
        const estadoEmp = localStorage.getItem("estadoEmp");

        const dirEmp = localStorage.getItem("direEmp");

        if (!props.formData.data) {
            setIdentificacion(storedIdentificacion);
            setRuc(storedRuc);
            setCodIden(storedCodIden);
            setNombre(storedNombre);
            setSiglas(storedSiglas);
            setActivo(estadoEmp);
            setGroupId(storedGroupId);
            setRepresentanteLegal(storedRepresentanteLegal);
            setDireccion(dirEmp)
        } else {

            if (props.formData.data) {
                const datForm = props.formData.data;
                setIdentificacion(datForm["numeroIdentificacion"]);
                setRuc(datForm["ruc"]);
                setCodIden(datForm["codigoTipoIdentificacion"]);
                setNombre(datForm["nombreEmpresa"]);
                setSiglas(datForm["siglasEmpresa"]);
                setDireccion(datForm["direccion"]);
                setActivo(datForm["esActivo"]);
                setGroupId(datForm["idGrupoEmpresa"]);
                setRepresentanteLegal(datForm["nombreRepresentanteLegal"]);

                localStorage.setItem("idemEmpre", datForm["numeroIdentificacion"]);
                localStorage.setItem("rucEmp", datForm["ruc"]);
                localStorage.setItem("codIdEmp", datForm["codigoTipoIdentificacion"]);
                localStorage.setItem("nombEmp", datForm["nombreEmpresa"]);
                localStorage.setItem("sigEmp", datForm["siglasEmpresa"]);
                localStorage.setItem("activEmp", datForm["esActivo"]);
                localStorage.setItem("groupEmp", datForm["idGrupoEmpresa"]);
                localStorage.setItem("repreEmpre", datForm["nombreRepresentanteLegal"]);
            }
        }
    }, [props, getGroup]);

    // Función de validación para números (solo números permitidos)
    const handleNumberChange = (e, setter, storageKey) => {
        const value = e.target.value;
        // Solo permitir números
        if (/^\d*$/.test(value)) {
            setter(value);
            localStorage.setItem(storageKey, value);
        }
    };

    // Función de validación para texto (solo letras y espacios permitidos)
    const handleTextChange = (e, setter, storageKey) => {
        const value = e.target.value;
        // Solo permitir letras y espacios
        if (/^[a-zA-Z\s]*$/.test(value)) {
            setter(value);
            localStorage.setItem(storageKey, value);
        }
    };

    const normalTextChange = (e, setter, storageKey) => {
        const value = e.target.value;
        setter(value);
        localStorage.setItem(storageKey, value);
    };

    return (
        <div className="row justify-content-center">
            <div className="card-body">
                <div className="row">
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label>Identificación</label>
                            <input
                                id="identificacion"
                                name="identificacion"
                                maxLength={13}
                                value={identificacion}
                                onChange={e => handleNumberChange(e, setIdentificacion, 'idemEmpre')}
                                className="form-control"
                                placeholder="Ingresar identificación"
                            />
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label>Ruc</label>
                            <input
                                id="ruc"
                                name="ruc"
                                maxLength={13}
                                value={ruc}
                                onChange={e => handleNumberChange(e, setRuc, 'rucEmp')}
                                className="form-control"
                                placeholder="Ingresar RUC"
                            />
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label>Establecimiento</label>
                            <input
                                id="estb"
                                name="estb"
                                maxLength={2}
                                value={codigoIden}
                                onChange={e => handleNumberChange(e, setCodIden, 'codIdEmp')}
                                className="form-control"
                                placeholder="Ingresar establecimiento"
                            />
                        </div>
                    </div>
                    <div className="col-sm-8">
                        <div className="form-group">
                            <label>Nombre</label>
                            <input
                                id="nombre"
                                name="nombre"
                                maxLength={100}
                                type="text"
                                value={nombre}
                                onChange={e => handleTextChange(e, setNombre, 'nombEmp')}
                                className="form-control"
                                placeholder="Ingresar Nombre"
                            />
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label>Siglas</label>
                            <input
                                id="siglas"
                                name="siglas"
                                maxLength={10}
                                type="text"
                                value={siglas}
                                onChange={e => handleTextChange(e, setSiglas, 'sigEmp')}
                                className="form-control"
                                placeholder="Ingresar siglas"
                            />
                        </div>
                    </div>
                    <div className="col-sm-12">
                        <div className="form-group">
                            <label>Dirección</label>
                            <input
                                id="direccion"
                                name="direccion"
                                maxLength={1000}
                                type="text"
                                value={direccion}
                                onChange={e => normalTextChange(e, setDireccion, 'direEmp')}
                                className="form-control"
                                placeholder="Ingresar dirección"
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Representante legal</label>
                            <input
                                id="representante"
                                name="representante"
                                maxLength={1000}
                                type="text"
                                value={representante}
                                onChange={e => handleTextChange(e, setRepresentanteLegal, 'repreEmpre')}
                                className="form-control"
                                placeholder="Ingresar Representante legal"
                            />
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <label>Grupos</label>
                            <select
                                name="grupo"
                                id="grupo"
                                value={groupId} // Valor seleccionado
                                onChange={e => {
                                    setGroupId(e.target.value);
                                    localStorage.setItem('groupEmp', e.target.value);
                                }}
                                className="form-control"
                            >
                                <option value="">Seleccionar grupo</option>
                                {objGrupo.map(option => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="col-sm-4">
                        <div className="form-group">
                            <label>Estado</label>
                            <select
                                className="form-control"
                                id="estado"
                                name="estado"
                                value={esActivo} // Sincronización del estado con el select
                                onChange={e => { setActivo(e.target.value); localStorage.setItem('estadoEmp', e.target.value); }} // Actualización del estado
                            >
                                <option value="">Seleccionar estado</option>
                                <option value="S">Activo</option>
                                <option value="N">Inactivo</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
